<template>
  <div>
    <TableFilters
      :filters="['']"
      :columns="columns"
      v-model="filter"
      @updateColumnsTable="updateColumnsTable"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <!-- {{suppliers}} -->
    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="suppliers"
              item-key="id"
              class="row-pointer product-list"
              id="indextable13"
            >
              <template v-slot:item.is_active="{ item }">
                {{ item.is_active ? 'Active' : 'Archieve' }}</template
              >
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import ProductListPdf from './PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import axios from '@/plugins/axios';

export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        align: 'left',
        disabled: false,
        sortable: false,
        render: (item) => item?.name,
      },
      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        align: 'left',
        disabled: false,
        width: '25%',
        sortable: false,
        render: (item) => item?.reference_number,
      },
      {
        text: 'Due Amount',
        value: 'due_amount',
        show: true,
        align: 'right',
        disabled: false,
        width: '25%',
        sortable: false,
        render: (item) => item?.due_amount,
      },
      {
        text: 'Status',
        value: 'is_active',
        show: true,
        disabled: false,
        align: 'center',
        width: '25%',
        sortable: false,
        render: (item) => (item?.is_active ? 'Active' : 'Archieve'),
      },
    ],
    suppliers: [],
    hide: '',
    // Filters
    filter: {
      name: '',
      customer: '',
      status: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductListPdf,
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;
      axios
        .get(`reports/supplier`)

        .then((res) => {
          let i = 1;
          this.suppliers = res.data.rows;
          this.suppliers.map((p) => {
            p.no = i;
            i++;
          });
          setTimeout(() => {
            callBack();
            // Update Pdf To List

            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.suppliers);
            // Update Pdf To List_Title
            this.$store.commit('UPDATE_PDF_TITLE', 'Suppliers');
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

          this.messages = err.data.title;
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.suppliers.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 2000);
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.suppliers);
        for (let x = 0; x < Data.length; x++) {
          Data[x].is_active = Data[x].is_active ? 'Active' : 'Archieve';
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica');
        doc.text('Suppliers Report', 15, 5);

        doc.setFontSize(9);
        doc.text(
          246,
          5,
          `Generated Date and Time  -  ${moment(today).format('DD-MM-YYYY HH:MM:SS')}`,
          'center',
        );

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: 10,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-suppliers.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable13');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-suppliers.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
